module.exports = __webpack_public_path__ + "static/media/icon-todo-today.0bbdda96.svg";